import React, { useState } from 'react';

function PreRequest() {
  let preReqText = "我们会在服务完成后通知预先登记的用户"


  return (
    <div>
      <div className="preForm">
        <div className="preFormContent">
          <p className="preFormTitle">EnglishTutor 预先登记</p>
          <p className="preFormDis"> {preReqText} </p>
        </div>
        <div className="preFormBox" data-mooform-id="22195778-0b79-46e9-8a15-c89680bc38f3" ></div>
      </div>
    </div>
  );
}

export default PreRequest;